import { BehaviorSubject, Observable, of, retry, switchMap, throwError, timeout, timer } from 'rxjs';

const CONVERT_SECONDS_TO_MS = 1000;
interface PollCmd<TApiArgs, TApiResponse> {
  intervalInSeconds: number;
  timeoutInSeconds: number;
  apiCall: (arg?: TApiArgs) => Observable<TApiResponse>;
  shouldContinuePolling: (arg: TApiResponse) => boolean;
  manualForceStop: BehaviorSubject<boolean>;
}

export function poll<TApiArgs, TApiResponse>(
  input: PollCmd<TApiArgs, TApiResponse>
): Observable<TApiResponse> {
  return input.apiCall().pipe(
    switchMap((apiResponse) => {
      if (input.shouldContinuePolling(apiResponse)) {
        return throwError(() => 'CONDITION_NOT_REACHED');
      }

      return of(apiResponse);
    }),
    retry({
      delay: () => {
        if (input.manualForceStop.value === true) {
          return throwError(() => 'STOP_POLLING_VIA_USER_ACTION');
        }
        return timer(input.intervalInSeconds * CONVERT_SECONDS_TO_MS);
      },
    }),
    timeout({ first: input.timeoutInSeconds * CONVERT_SECONDS_TO_MS })
  );
}
